import { logInAdmin, logOutAdmin } from "@global-state/global/slice";
import { IAdmin } from "@interfaces/admin/admin";
import { authApi, logApi } from "@RTKQuery/basic";

const authLogApi = logApi.injectEndpoints({
    endpoints: (build) => ({
        adminLogin: build.mutation<IAdmin, {
            email: string,
            password: string,
        }>({
            query: (data) => {
                return {
                    url: "auth/login",
                    method: "POST",
                    body: data
                }
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    dispatch(logInAdmin());
                } catch { }
            },
        })
    }),
    overrideExisting: false,
});

export const {
    useAdminLoginMutation
} = authLogApi;

const authAuthApi = authApi.injectEndpoints({
    endpoints: (build) => ({
        getAdmin: build.query<IAdmin, void>({
            query: () => "auth/account",
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(logInAdmin());
                } catch {
                    dispatch(logOutAdmin());
                }
            },
        }),
        adminLogout: build.mutation<void, void>({
            query: () => {
                return {
                    url: "auth/logout",
                    method: "POST"
                }
            },
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    dispatch(authAuthApi.util.resetApiState());

                    dispatch(logOutAdmin());
                } catch { }
            },
        })
    }),
    overrideExisting: false,
})

export const {
    useLazyGetAdminQuery,
    useAdminLogoutMutation
} = authAuthApi;

export default authAuthApi;